import React from 'react';
import ReactDOM from 'react-dom/client'; // or 'react-dom'
import './index.css'; // <-- CRITICAL: This line imports your main CSS file
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);